<template>
  <div>
    <section :class="$style.sectionRoot">
      <header :class="$style.sectionHeader">
        LDAP Custom Attributes
        <NewBadge />
      </header>
      <div :class="$style.sectionContent">
        <KnowledgeBaseArticle
          :includeInfoIcon="false"
          infoText="Create and store custom attributes by entering the custom attribute
            name which will map to the corresponding translation in the dropdown.
            View complete list of JumpCloud attributes"
          :kbLink="KbArticleLdapCustomAttributes"
          kbText="Learn More"
        />
        <DatabaseAttributeFields
          v-for="(value, index) in listItem"
          :key="index"
          :customAttributeList="ldapCustomAttributes"
          customValuePlaceholder="Attribute Name"
          :dropdownLabel="dropdownLabel"
          :handleChangeListItem="(newListItem, columnName) => {
            handleChangeListItem(index, newListItem);
          }"
          :inputDisabled="true"
          :inputLabel="inputLabel"
          :inputMode="false"
          :listItem="value"
          :valueValidation="'required|maxCharacterValidation'"
        />
      </div>
    </section>
  </div>
</template>
<script>

import * as Constants from 'client/util/Constants';
import { ldapCustomAttributes } from 'client/util/Constants/ApplicationConstants';
import { mapActions, mapGetters } from 'vuex';
import DatabaseAttributeFields from 'client/components/Applications/DatabaseAttributeFields.vue';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';
import KnowledgeBaseArticle from 'client/components/FormValidation/KnowledgeBaseArticle.vue';
import NewBadge from 'client/components/Badges/NewBadge.vue';

const {
  ItemTypeConsts,
  StoreModelMap,
} = Constants;
const { ldap } = ItemTypeConsts;
const ldapModel = StoreModelMap[ldap];

export default {
  name: 'LdapCustomAttributes',

  inject: ['$validator'],

  components: {
    DatabaseAttributeFields,
    KnowledgeBaseArticle,
    NewBadge,
  },

  data: () => ({
    ldapCustomAttributes,
    dropdownLabel: 'JumpCloud Attribute Name',
    inputLabel: 'Custom Attribute',
    KbArticleLdapCustomAttributes: KbArticleUrls.ldapCustomAttributes,
  }),

  computed: {
    ...mapGetters(ldapModel, [
      'getLdapCustomAttributes',
    ]),

    listItem() {
      return this.getLdapCustomAttributes;
    },
  },

  beforeMount() {
    const maxCharacterValue = value => value.length < 253;

    this.$validator.extend('maxCharacterValidation', {
      getMessage: '* 253 character limit.',
      validate: maxCharacterValue,
    });
  },

  async mounted() {
    await this.fetchLdapCustomAttributes();
  },

  methods: {
    ...mapActions(ldapModel, [
      'fetchLdapCustomAttributes',
      'updateLdapCustomAttributes',
    ]),

    handleChangeListItem(index, newListItem) {
      this.updateLdapCustomAttributes({ index, newListItem });
    },
  },
};
</script>

<style module>
@import '../../components/FormValidation/css/formFields.css';
@import '../../css/sections.css';
@import '../../css/flex.css';
</style>
